export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-24">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            Comece a usar o CSSBuy<br />Spreadsheet hoje
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mb-10 max-w-lg mx-auto leading-relaxed">
            Economize horas de pesquisa e encontre os melhores produtos em segundos. Milhares de utilizadores já confiam na nossa planilha.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 px-8 py-3.5 bg-primary-600 text-white text-sm font-semibold rounded-full hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Acessar Agora
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 px-8 py-3.5 border border-foreground-200 text-foreground-700 text-sm font-medium rounded-full hover:bg-foreground-950 hover:text-white hover:border-foreground-950 transition-all cursor-pointer whitespace-nowrap"
            >
              Ver Spreadsheet
              <i className="ri-external-link-line text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}